module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.inputClass, this.stacked ? 'custom-controls-stacked' : '']
  }, _vm._l((_vm.formOptions), function(option) {
    return _c('label', {
      class: [_vm.checkboxClass, _vm.custom ? 'custom-radio' : null]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.localValue),
        expression: "localValue"
      }],
      ref: "inputs",
      refInFor: true,
      class: _vm.custom ? 'custom-control-input' : null,
      attrs: {
        "type": "radio",
        "name": option.name,
        "id": option.id,
        "disabled": option.disabled
      },
      domProps: {
        "value": option.value,
        "checked": _vm._q(_vm.localValue, option.value)
      },
      on: {
        "__c": function($event) {
          _vm.localValue = option.value
        }
      }
    }), _vm._v(" "), (_vm.custom) ? _c('span', {
      staticClass: "custom-control-indicator"
    }) : _vm._e(), _vm._v(" "), _c('span', {
      class: _vm.custom ? 'custom-control-description' : null,
      domProps: {
        "innerHTML": _vm._s(option.text)
      }
    })])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec01195e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/form-radio.vue
// module id = 264
// module chunks = 0